import React from "react";
import { RUBRICS, PILLARS } from "../data/newsArticles";

const Chip = ({ active, onClick, children, testid }) => (
  <button
    type="button"
    onClick={onClick}
    className={`font-condensed uppercase tracking-widest text-[12px] md:text-[13px] px-3 py-1.5 transition-colors duration-200 border ${
      active
        ? "bg-lime text-dodgers border-lime"
        : "border-galactico/30 text-galactico hover:border-lime"
    }`}
    data-testid={testid}
    aria-pressed={active}
  >
    {children}
  </button>
);

const NewsFilters = ({
  activeRubrics,
  setActiveRubrics,
  activePillars,
  setActivePillars,
  total,
  shown,
}) => {
  const toggle = (arr, setArr, value) => {
    if (arr.includes(value)) {
      setArr(arr.filter((v) => v !== value));
    } else {
      setArr([...arr, value]);
    }
  };

  const reset = () => {
    setActiveRubrics([]);
    setActivePillars([]);
  };

  const hasFilters = activeRubrics.length > 0 || activePillars.length > 0;

  return (
    <div
      className="sticky top-20 z-30 bg-dodgers py-4 border-b border-lime/30"
      data-testid="news-filters"
    >
      <div className="container-os">
        <div className="flex flex-col gap-4 md:flex-row md:items-start md:gap-8">
          <div className="flex flex-col gap-3 md:flex-1">
            <span className="font-condensed uppercase tracking-widest text-[11px] text-mandrogni">
              Rubrica
            </span>
            <div className="flex flex-wrap gap-2">
              {RUBRICS.map((r) => (
                <Chip
                  key={r}
                  active={activeRubrics.includes(r)}
                  onClick={() => toggle(activeRubrics, setActiveRubrics, r)}
                  testid={`filter-rubric-${r.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {r}
                </Chip>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-3 md:flex-1">
            <span className="font-condensed uppercase tracking-widest text-[11px] text-mandrogni">
              Pilastro
            </span>
            <div className="flex flex-wrap gap-2">
              {PILLARS.map((p) => (
                <Chip
                  key={p}
                  active={activePillars.includes(p)}
                  onClick={() => toggle(activePillars, setActivePillars, p)}
                  testid={`filter-pillar-${p.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {p}
                </Chip>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-4 flex items-center justify-between gap-4 flex-wrap">
          <span
            className="font-condensed uppercase tracking-widest text-[11px] text-galactico"
            data-testid="news-counter"
          >
            {shown} di {total} articoli mostrati
          </span>
          {hasFilters && (
            <button
              type="button"
              onClick={reset}
              className="font-condensed uppercase tracking-widest text-[11px] text-lime hover:text-galactico transition-colors"
              data-testid="filter-reset"
            >
              Reset filtri ×
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewsFilters;
